<template>
  <div>
    <Hero title="Lernen einfach strukturiert." />
    <ul
      class="parentbtn d-flex justify-content-center mt-8 flex-md-row flex-column"
    ></ul>

    <section class="container discoverSection">
      <b-row class="px-2">
        <b-col
          cols="12"
          md="6"
          order="2"
          order-md="1"
          align-self="center"
          class="pr-4"
        >
          <div
            v-lazy-container
            class="scaling-svg-container"
          >
            <ImgStrukture />
          </div>
        </b-col>
        <b-col
          cols="12"
          md="6"
          order="1"
          order-md="2"
          align-self="center"
          class="pl-4"
        >
          <h3 class="mt-4">{{ $t('structure') | capitalize }}</h3>
          <p class="pt-3 excerpt">
            {{
              $t(
                'Füge Arbeitsaufträge sowie digitale und analoge Lernressourcen zu strukturierten Lernpfaden zusammen'
              )
            }}.
          </p>
        </b-col>
      </b-row>

      <b-row class="px-2">
        <b-col
          cols="12"
          md="6"
          order="1"
          order-md="2"
          align-self="center"
          class="pr-4"
        >
          <div
            v-lazy-container
            class="scaling-svg-container"
          >
            <ImgLernen />
          </div>
        </b-col>
        <b-col
          cols="12"
          md="6"
          align-self="center"
          class="pl-4"
        >
          <h3 class="mt-4">{{ $t('Lernen') | capitalize }}</h3>
          <p class="pt-3 excerpt">
            {{
              $t(
                'Lernende arbeiten selbstgesteuert an ihren Lernpfaden und machen ihr Lernen sichtbar'
              )
            }}.
          </p>
        </b-col>
      </b-row>

      <b-row class="px-2">
        <b-col
          cols="12"
          md="6"
          order="2"
          order-md="1"
          align-selft="center"
          class="pr-4"
        >
          <div
            v-lazy-container
            class="scaling-svg-container"
          >
            <ImgBegleiten />
          </div>
        </b-col>
        <b-col
          cols="12"
          md="6"
          order="1"
          order-md="2"
          align-self="center"
          class="pl-4"
        >
          <h3 class="mt-4">{{ $t('Begleiten') }}</h3>
          <p class="pt-3 excerpt">
            {{
              $t(
                'Regelmässiges individuelles Feedback motiviert und gibt den Lernenden Sicherheit'
              )
            }}.
          </p>
        </b-col>
      </b-row>
    </section>

    <section class="aboutSection sectionSmoothBg light">
      <div class="container">
        <b-row class="px-2">
          <b-col
            cols="12"
            md="6"
          >
            <h3>{{ $t('über Lernpfad') }}</h3>
            <p class="pt-4 mb-6 excerpt">
              {{
                $t(
                  'Lernpfad ist eine Micropublishing-Plattform, auf welcher Lehrpersonen Unterrichtsszenarien erstellen und beziehen können'
                )
              }}.
            </p>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <ul>
              <li class="d-flex">
                <span class="pr-2"><Oval /></span>
                <span>{{ $t('Für alle Unterrichtsformen geeignet') }}</span>
              </li>
              <li class="d-flex">
                <span class="pr-2"><Star /></span>
                <span>
                  {{
                    $t(
                      'Lehrmittelunabhängiges Tool zum Zusammenstellen von Lerninhalten'
                    )
                  }}
                </span>
              </li>
              <li class="d-flex">
                <span class="pr-2"><Triangle /></span>
                <span>
                  {{
                    $t(
                      'Lernende teilen ihre Arbeitsergebnisse direkt über Lernpfad'
                    )
                  }}
                </span>
              </li>
              <li class="d-flex">
                <span class="pr-2"><Oval /></span>
                <span>
                  {{
                    $t('Übersicht über individuelle Fortschritte der Lernenden')
                  }}
                </span>
              </li>
              <li class="d-flex">
                <span class="pr-2"><Triangle /></span>
                <span>
                  {{ $t('Einfaches veröffentlichen von Lernpfaden') }}
                </span>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
    </section>

    <section class="librarySection my-5">
      <b-container>
        <h3 class="bibliothek">{{ $t('Bibliothek') }}</h3>
        <p class="pt-4 mb-6 excerpt">
          {{ $t('Brauchst du Inspiration') }}?
          <br />
          {{
            $t(
              'Erkunde Lernpfad-Vorlagen in der Bibliothek und passe diese auf deine Bedürfnisse an'
            )
          }}.
        </p>

        <div v-if="dataReady">
          <LearnPathList
            :learn-paths="learnPaths"
            sub-url="/vorschau"
          />
        </div>
        <div v-else>
          <ContentSpinner />
        </div>
        <div class="parentbtn">
          <div class="wrapperLink">
            <nuxt-link
              :to="localePath('/bibliothek')"
              class="btnLink p-3"
            >
              {{ $t('Stöbern') }}
            </nuxt-link>
          </div>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import * as R from 'ramda'
import LearnPathUtils from '../mixins/LearnPathUtils'
import libraryGql from '../pages/bibliothek.gql'
import ImgStrukture from '../assets/images/start/ImgStruktur.svg'
import ImgLernen from '../assets/images/start/ImgLernen.svg'
import ImgBegleiten from '../assets/images/start/ImgBegleiten.svg'
import Oval from '../assets/images/start/Oval.svg'
import Star from '../assets/images/start/Star.svg'
import Triangle from '../assets/images/start/Triangle.svg'
import Hero from '../components/ui/Hero'
import ContentSpinner from '../components/ui/ContentSpinner'
import LearnPathList from './LearnPathList'
import { ampli } from '@/mixins/Amplitude'

// function shuffle(array) {
//   let currentIndex = array.length
//   let randomIndex

//   // While there remain elements to shuffle...
//   while (currentIndex !== 0) {

//     // Pick a remaining element...
//     randomIndex = Math.floor(Math.random() * currentIndex)
//     currentIndex--;

//     // And swap it with the current element.
//     [array[currentIndex], array[randomIndex]] = [
//       array[randomIndex], array[currentIndex]]
//   }
//   return array
// }

export default {
  components: {
    ImgStrukture,
    ImgLernen,
    ImgBegleiten,
    Hero,
    Star,
    Oval,
    Triangle,
    LearnPathList,
    ContentSpinner,
  },
  mixins: [LearnPathUtils, ampli],
  data() {
    return {
      ImgStrukture,
      dataReady: false,
    }
  },
  created() {
    ampli.anonymousPageViewed()
  },
  apollo: {
    learnPaths: {
      result({ data, loading, networkStatus }) {
        this.dataReady = true
      },
      query: libraryGql,
      update(data) {
        const lp = R.pathOr([], ['libraryLearnPaths', 'edges'], data)
        return lp.slice(0, 4)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/style/vars';
@import '../assets/style/utils';

$max-width: calculateRem(780px);

.parentbtn {
  .wrapperLink {
    margin: 0 calculateRem(20px);
    padding: 0;
    background-color: transparent;
  }

  .btnLink {
    display: block;
    width: 100%;
    font-weight: 500;
    @include fontSize(23px);
    border-radius: 0;
    padding: calculateRem(20px) calculateRem(50px);
  }

  .btnLink.contrast {
    font-weight: 400;
    color: $darkblue;
    background-color: white;
    border: $darkblue 1px solid;
    &:hover {
      background-color: $darkblue-active;
      color: white;
    }
  }
}

.scaling-svg-container {
  position: relative;
  height: 0;
  width: 100%;
  padding: 0;
  padding-bottom: 100%;

  svg {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    padding: 3rem;
  }
}

h3 {
  color: $darkblue;
  @include fontSize(50px);
  max-width: $max-width;
  // margin: auto;
  font-weight: 700;
}

h4 {
  @include fontSize(30px);
  max-width: $max-width;
  font-weight: 700;
}

p {
  @include fontSizeLineHeight(28px, 32px);
}

ul {
  list-style-type: none;
  padding-left: 0;
}

.excerpt {
  line-height: 1.4;
}

.discoverSection {
  margin-top: calculateRem(60px);

  h2 {
    text-align: center;
    @include fontSize(44px);
    max-width: $max-width;
    margin: 0 auto calculateRem(50px) auto;
  }

  img {
    width: 100%;
  }

  h3 {
    color: $darkblue;
    @include fontSize(50px);
    max-width: $max-width;
    // margin: auto;
    font-weight: 700;
  }
}

.sectionSmoothBg {
  color: $darkblue;
  padding: calculateRem(60px) 0 calculateRem(50px);
  background-color: #f4f4f4;

  h3,
  h4,
  p {
    color: $darkblue;
  }

  ul {
    max-width: $max-width;
    padding-left: 0;
    font-weight: 500;
  }

  li {
    padding: calculateRem(10px) 0;
    margin-left: 0px;
  }
}

.librarySection {
  .bibliothek {
    color: $darkblue;
  }

  .parentbtn {
    margin-left: auto;
    width: max-content;
  }
}

@media (max-width: map-get($grid-breakpoints, md)) {
  section {
    margin-top: calculateRem(70px) !important;
  }

  .parentbtn {
    .wrapperLink {
      margin: 0 auto;
      width: 80vw;
    }
    .btnLink {
      width: 100%;
    }
  }

  .librarySection .parentbtn {
    margin: 0 auto;
  }
}
</style>
